(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-announce"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* Minuteur : date cible (minuit local) ou minuteur de session (repart à chaque visite). */
  if (!customElements.get('sd-countdown')) {
    class SDCountdown extends HTMLElement {
      connectedCallback() {
        var raw = (this.dataset.target || '').trim();
        var hours = parseInt(this.dataset.timerHours || '0', 10);
        var secs = parseInt(this.dataset.timerSeconds || '0', 10);
        if (secs > 0) {
          this.target = Date.now() + secs * 1000;
        } else if (hours > 0) {
          this.target = Date.now() + hours * 3600 * 1000;
        } else {
          var m = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
          if (!m) { this.hidden = true; return; }
          this.target = new Date(+m[1], +m[2] - 1, +m[3], 0, 0, 0, 0).getTime();
        }
        this.root = this.closest('.sd-announce');
        this.nums = {};
        var self = this;
        this.querySelectorAll('[data-unit]').forEach(function (el) { self.nums[el.dataset.unit] = el; });
        this.tick = this.tick.bind(this);
        this.tick();
        if (!this.done) this.timer = setInterval(this.tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        var diff = Math.max(0, Math.floor((this.target - Date.now()) / 1000));
        if (diff <= 0) { this.finish(); return; }
        var d = Math.floor(diff / 86400), h = Math.floor((diff % 86400) / 3600),
            mi = Math.floor((diff % 3600) / 60), se = diff % 60;
        var vals = { d: pad(d), h: pad(h), m: pad(mi), s: pad(se) };
        for (var k in vals) { if (this.nums[k] && this.nums[k].textContent !== vals[k]) this.nums[k].textContent = vals[k]; }
      }
      finish() {
        this.done = true;
        clearInterval(this.timer);
        this.hidden = true;
        if (!this.root) return;
        var after = this.root.querySelector('[data-sd-after]');
        var before = this.root.querySelectorAll('[data-sd-before]');
        if (after) { after.hidden = false; before.forEach(function (el) { el.hidden = true; }); }
        else if (!before.length) { this.root.hidden = true; this.root.style.display = 'none'; }
      }
    }
    customElements.define('sd-countdown', SDCountdown);
  }

  /* Messages tournants : un seul visible, pause au survol / au focus. */
  if (!customElements.get('sd-rotator')) {
    class SDRotator extends HTMLElement {
      connectedCallback() {
        this.msgs = Array.prototype.slice.call(this.querySelectorAll('[data-sd-msg]'));
        this.index = 0;
        this.paused = false;
        if (this.msgs.length < 2) return;
        var self = this;
        var pause = function () { self.paused = true; };
        var resume = function () { self.paused = false; };
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        var seconds = Math.min(15, Math.max(3, parseInt(this.dataset.interval || '5', 10) || 5));
        this.timer = setInterval(function () { if (!self.paused && !document.hidden) self.show(self.index + 1); }, seconds * 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      show(i) {
        var n = this.msgs.length;
        this.index = ((i % n) + n) % n;
        var current = this.index;
        this.msgs.forEach(function (el, k) {
          var on = k === current;
          el.classList.toggle('is-on', on);
          if (on) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true');
          var a = el.querySelector('a');
          if (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); }
        });
      }
    }
    customElements.define('sd-rotator', SDRotator);
  }

  /* Éditeur de thème : sélectionner un bloc message l'affiche. */
  document.addEventListener('shopify:block:select', function (e) {
    var msg = e.target && e.target.closest && e.target.closest('[data-sd-msg]');
    var rot = msg && msg.closest('sd-rotator');
    if (rot && rot.show) rot.show(rot.msgs.indexOf(msg));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setOpen(btn, open) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
    var item = btn.closest('.sd-faq__item');
    if (item) item.classList.toggle('is-open', open);
  }
  function toggle(btn, open) {
    var list = btn.closest('[data-sd-faq]');
    if (open && list && list.hasAttribute('data-one-open')) {
      list.querySelectorAll('[data-sd-faq-btn][aria-expanded="true"]').forEach(function (b) { if (b !== btn) setOpen(b, false); });
    }
    setOpen(btn, open);
  }
  /* délégué sur document : continue de fonctionner après un rechargement de section dans l'éditeur */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-sd-faq-btn]');
    if (!btn) return;
    toggle(btn, btn.getAttribute('aria-expanded') !== 'true');
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-sd-faq-btn]');
    if (el) toggle(el, true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-page-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Suivi : ouvre la destination réglée ([number] = numéro). Lien absolu = nouvel onglet, chemin = même onglet. */
    function onSubmit(e) {
      var form = e.target.closest && e.target.closest('form[data-sd-track]');
      if (!form) return;
      e.preventDefault();
      var input = form.querySelector('input[name="tracking"]');
      if (!input) return;
      var value = (input.value || '').replace(/\s+/g, '').trim();
      if (!value) {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      var tpl = form.getAttribute('data-url') || 'https://parcelsapp.com/en/tracking/[number]';
      var num = encodeURIComponent(value);
      var url = tpl.indexOf('[number]') >= 0 ? tpl.split('[number]').join(num) : tpl + num;
      if (/^https?:\/\//i.test(url)) {
        var win = window.open(url, '_blank');
        if (win) {
          try { win.opener = null; } catch (err) { /* ignore */ }
        } else {
          window.location.href = url;
        }
      } else {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location.href = root + url.replace(/^\/+/, '');
      }
    }
    document.addEventListener('submit', onSubmit);
    document.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('form[data-sd-track] input[name="tracking"]')) {
        e.target.removeAttribute('aria-invalid');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__sdInit) return;
    var track = root.querySelector('[data-sd-reviews-track]');
    var nav = root.querySelector('[data-sd-reviews-nav]');
    if (!track || !nav) return;
    root.__sdInit = true;
    var prev = nav.querySelector('[data-sd-reviews-prev]');
    var next = nav.querySelector('[data-sd-reviews-next]');
    function step() {
      var slide = track.querySelector('.sd-reviews__slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var per = Math.max(1, Math.floor((track.clientWidth + gap) / (slide.offsetWidth + gap)));
      return per * (slide.offsetWidth + gap);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    if ('ResizeObserver' in window) { root.__sdRO = new ResizeObserver(update); root.__sdRO.observe(track); }
    else window.addEventListener('resize', update);
    update();
  }
  function all() { document.querySelectorAll('[data-sd-reviews]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-sd-reviews]');
    if (root && root.__sdRO) root.__sdRO.disconnect();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest && e.target.closest('.sd-reviews__slide');
    var track = slide && slide.closest('[data-sd-reviews-track]');
    var first = track && track.querySelector('.sd-reviews__slide');
    if (first) track.scrollTo({ left: slide.offsetLeft - first.offsetLeft, behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-squad"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Bouton « Choose [shade] » : s'il y a une fiche produit sd-product sur la page, on émet sd:select-shade
     (la fiche choisit la teinte et remonte aux offres) ; sinon le lien est suivi normalement. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-sd-shade]');
    if (!btn || e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (!document.querySelector('[data-sdp] [data-sdp-json]')) return;
    e.preventDefault();
    btn.dispatchEvent(new CustomEvent('sd:select-shade', { bubbles: true, detail: { shade: btn.getAttribute('data-sd-shade') } }));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
